/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { FunctionComponent, VNode } from 'preact';
import { HTMLAttributes } from 'preact/compat';
import { VComponent } from '@adobe-commerce/elsie/lib';
import '@/plp/components/FacetList/FacetList.css';

export interface FacetListProps extends HTMLAttributes<HTMLDivElement> {
  selectedFacets: VNode;
  facets: VNode;
}

export const FacetList: FunctionComponent<FacetListProps> = ({ selectedFacets, facets }) => {
  return (
    <>
      <VComponent className="product-discovery-facet-list__selected-filters" node={selectedFacets} />
      <VComponent className="product-discovery-facet-list__facet-options" node={facets} />
    </>
  );
};
